import { matchPath } from 'react-router'
import type { Instacart_Infra_Totem_V1_System as TotemSystem } from '../../__codegen__/api'

export type TotemRouteOwnerMappingEntry = {
  routePattern: string
  hasDevTooling?: boolean
  totemSystem?: TotemSystem
}

let totemRouteOwnerMapping: Record<string, TotemRouteOwnerMappingEntry> = {}

/**
 * Match a pathname against the registered totem route patterns and return the
 * first matching route key (or undefined).
 */
export const getMatchedKey = (pathname: string): string | undefined => {
  return Object.keys(totemRouteOwnerMapping).find(
    key => matchPath(pathname, { path: key, exact: true })?.path
  )
}

export const getRouteOwnerEntry = (pathname: string): TotemRouteOwnerMappingEntry | undefined => {
  const matchedKey = getMatchedKey(pathname)
  return matchedKey ? totemRouteOwnerMapping[matchedKey] : undefined
}

export const setTotemRouteOwnerMapping = (mapping: Record<string, TotemRouteOwnerMappingEntry>) => {
  totemRouteOwnerMapping = mapping
}

export const updateTotemSystem = (totemSystem: TotemSystem) => {
  const matchedKey = getMatchedKey(window.location.pathname)
  if (!matchedKey) return

  totemRouteOwnerMapping[matchedKey] = {
    ...totemRouteOwnerMapping[matchedKey],
    totemSystem,
  }
}

/** True once at least one route has had its Totem system populated. */
export const hasAnyTotemSystem = (): boolean =>
  Object.values(totemRouteOwnerMapping).some(entry => entry.totemSystem)

/**
 * Resolve the Totem system that owns the currently-active route. Used to tag
 * errors (Sentry) with the owning team the same way RUM does.
 */
export const getCurrentTotemSystem = (): TotemSystem | undefined => {
  return getRouteOwnerEntry(window.location.pathname)?.totemSystem
}
